// Copyright aptihealth, inc. 2019 All Rights Reserved

import React from "react";
import { getAutomationDataAttr } from "../../../utils/automationUtils";

const SlotTile = (props) => {
  const { active, displayText, timeSlot } = props;
  let classes = "Schedule__TimeSlot-options mr-2 mb-3 fs-15";

  if (props.className) {
    classes = classes + " " + props.className;
  }
  if (active == timeSlot) {
    classes = classes + " " + "Schedule__TimeSlot-options--active";
  }

  return (
    <div className={classes} onClick={() => props.click(timeSlot)}>
      <p className="m-0" {...getAutomationDataAttr("Schedule__TimeSlot")}>
        {displayText}
      </p>
    </div>
  );
};

export default SlotTile;
